import { Injectable} from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class DataService {

    private baseUrl = '/api/data/';

    constructor(private http: Http) {}

    delete(type: string, filePath: string): Promise<any> {
        return this.http.get(this.baseUrl+type+'/delete/'+filePath)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('Data API error', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/data.service.ts